'use strict';

var makeNonNullableArray = require('./makeNonNullableArray.js');

/**
 * Returns the first non-nullable element from an array.
 * If a non-array is provided, it will be treated as a single-element array.
 *
 * @template T - The type of the elements in the array.
 * @param x - The array or array-like object.
 * @returns The first non-nullable element from the array, or `undefined` if the array is empty or contains only nullable elements.
 */ function firstNonNullable(x) {
    return makeNonNullableArray(x)[0];
}

module.exports = firstNonNullable;
